import * as ActionTypes from '../actions/ActionTypes';

const defaultTeamSummary = {
    loading: true,
    totalEmployees: 0,
    totalVisits: 0,
    totalFormsSubmitted: 0,
    totalSchedules: 0,
};

const defaultTeamVisit = {
    loading: true,
    results: [],
    groupedVisitsByEmployee: {},
    groupedMileageByEmployee: {},
};

export default function Dashboard(
    state = {
        isLoading: false,
        teamSummary: defaultTeamSummary,
        teamVisit: defaultTeamVisit,
    },
    action
) {
    switch (action.type) {
        case ActionTypes.CLEAR_DASHBOARD:
            return {
                ...state,
                teamSummary: defaultTeamSummary,
                teamVisit: defaultTeamVisit,
            };
        case ActionTypes.SET_TEAM_DASHBOARD_SUMMARY:
            return {
                ...state,
                teamSummary: action.payload || {},
            };

        case ActionTypes.SET_TEAM_DASHBOARD_VISITS:
            return { ...state, teamVisit: { ...state.teamVisit, ...action.payload } };

        default:
            return state;
    }
}
